import Vue from '@/setup'

import { ContactUtil } from '@/utils/Contact'

import { CHANNEL_SERVICEPORTAL } from '@/config/constants'

const { $backend } = Vue.prototype

export const ContactHelper = {
  ...ContactUtil,

  async getInfo($t, distributionPartnerNumber, partnerNumber, channel) {
    if (!distributionPartnerNumber) {
      throw new Error('No distributionPartnerNumber')
    }

    if (channel === CHANNEL_SERVICEPORTAL) {
      partnerNumber = undefined
    }

    const data = await $backend.ovp.getDistributionPartnerContactInfo({ distributionPartnerNumber, partnerNumber })

    return {
      alva: !!data.alva,
      chat: data.chatOpeningTime ? ContactHelper.processChat(data, $t) : false,
      cobrowsing: data.coBrowsingOpeningTime ? ContactHelper.processCoBrowsing(data, $t) : false,
      email: data.email,
      phone: data.openingTime ? ContactHelper.processPhone(data, $t) : false,
    }
  },

  async getRawInfo(distributionPartnerNumber, partnerNumber, channel) {
    if (!distributionPartnerNumber) {
      throw new Error('No distributionPartnerNumber')
    }

    if (channel === CHANNEL_SERVICEPORTAL) {
      partnerNumber = undefined
    }

    return await $backend.ovp.getDistributionPartnerContactInfo({ distributionPartnerNumber, partnerNumber })
  },

  processChat({ chatOpeningTime }, $t) {
    return {
      active: ContactHelper.amIOpen(chatOpeningTime),
      enabled: chatOpeningTime.length > 0,
      times: chatOpeningTime.map(line => ContactHelper.processOpening(line, $t)),
    }
  },

  processCoBrowsing({ coBrowsingOpeningTime }, $t) {
    return {
      active: ContactHelper.amIOpen(coBrowsingOpeningTime),
      enabled: coBrowsingOpeningTime.length > 0,
      times: coBrowsingOpeningTime.map(line => ContactHelper.processOpening(line, $t)),
    }
  },

  processOpening(line, $t) {
    return {
      days: `${$t(`date.days.${line.start}`)} - ${$t(`date.days.${line.end}`)}`,
      hours: `${line.startTime} - ${line.endTime}`,
    }
  },

  processPhone({ name, phoneNumber, openingTime }, $t) {
    return {
      name,
      active: ContactHelper.amIOpen(openingTime),
      enabled: true,
      nr: phoneNumber,
      times: openingTime.map(line => ContactHelper.processOpening(line, $t)),
    }
  },
}
